import { BatteryTypeRef } from './BatteryReference';
import assignToThis from '../../helper/assignToThis';
import { ObjectOnly } from '@/classes/ObjectOnly';

export class ScenarioBattery {

    public socMinPercentage: number | null = null;
    public globalSocMaxPercentage: number | null = null;
    public isRechargeableByGrid: boolean | null = null;
    public socMaxChargeGrid: number | null = null;
    public isRechargeableByGenerator: boolean | null = null;
    public socMaxChargeGen: number | null = null;
    public socToleranceGridForming: number | null = 0.01;

    public typeRef: BatteryTypeRef | null = null;
    public isGridForming: boolean | null = null;

    public cRate: number | null = null;

    public chargeEfficiencyPercentage: number | null = null;
    public dischargeEfficiencyPercentage: number | null = null;

    public lifetimeCycles: number | null = null;

    public invertersLifetimeYear: number | null = null;

    public fromHour: number | null = null;
    public toHour: number | null = null;

    public constructor(obj: ObjectOnly = {}) {
      assignToThis(this, obj);

      this.typeRef = this.typeRef ? (BatteryTypeRef as any)[this.typeRef] : null;
    }
}
